import SEO from '../../components/SEO';
import React from 'react';
import { FileText } from 'lucide-react';

import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';

const TreatmentPlansPage = () => {
  return (
    <div className="min-h-screen bg-white">
      
      <Navigation />
      <SEO title="Individualized Treatment Plans" description="Personalized mental health treatment planning at SDORA Wellbeing. Collaborative, evidence-based plans tailored to each client's needs and recovery goals. Pikesville, MD." path="/services/treatment-plans" />
      
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-4">
            <FileText className="w-12 h-12 text-blue-600" />
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
              Individualized Treatment Plans
            </h1>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl">
            Comprehensive assessments and personalized treatment strategies tailored to your unique needs and goals.
          </p>
        </div>
      </div>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Process</h2>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mt-2"></span>
                  <div>
                    <h3 className="font-semibold text-lg">Custom Plans</h3>
                    <p className="text-gray-600">Every treatment plan is uniquely designed for you.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mt-2"></span>
                  <div>
                    <h3 className="font-semibold text-lg">Goal-Oriented</h3>
                    <p className="text-gray-600">Clear, achievable objectives guide your treatment journey.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mt-2"></span>
                  <div>
                    <h3 className="font-semibold text-lg">Progress Tracking</h3>
                    <p className="text-gray-600">Regular assessments to measure improvement and adjust strategies.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mt-2"></span>
                  <div>
                    <h3 className="font-semibold text-lg">Flexible Approach</h3>
                    <p className="text-gray-600">Treatment plans evolve with your changing needs.</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-green-50 p-8 rounded-xl">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Treatment Components</h2>
              <p className="text-gray-700 mb-4">Your individualized plan may include:</p>
              <ul className="space-y-2 text-gray-700">
                <li>• Initial comprehensive assessment</li>
                <li>• Specific treatment goals</li>
                <li>• Therapy modalities</li>
                <li>• Medication management (if needed)</li>
                <li>• Family involvement strategies</li>
                <li>• Progress milestones</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default TreatmentPlansPage;